<div class="hot-cold-card">
    <div class="section hot-section">
        <h2 i18n class="section-title">HOT</h2>
        <div class="numbers-container">
            @for (numDisplay of displayedHotNumbers; track $index) {
                <div class="number-box hot" [class]="numDisplay.backgroundClass">
                    {{ numDisplay.displayValue }}
                </div>
            }
        </div>
    </div>

    <div class="divider"></div>
    <div class="section cold-section">
        <h2 i18n class="section-title">COLD</h2>
        <div class="numbers-container">
            @for (numDisplay of displayedColdNumbers; track $index) {
                <div class="number-box cold" [class]="numDisplay.backgroundClass">
                    {{ numDisplay.displayValue }}
                </div>
            }
        </div>
    </div>
</div>
